import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface CreateUserDTO {
  fullname: string;
  username: string;
  date_of_birth: string;
  gender: string;
  email: string;
  phone_number: string;
  bio: string;
  role: string;
  password: string;
  confirm_password: string;
  media_id?: number;
  warehouse_id?: number;
}

export type CreateUserResp = BaseResAPI<null>;

const createUserInteractor = (
  params: CreateUserDTO
): Promise<CreateUserResp> => {
  const path = "/admin/user";
  return api.post(path, params);
};

export default createUserInteractor;
